const LOG_PREFIX = "[OCM][PageSense] "
let pageSense = async (utils) => {
    return new Promise((resolve, reject) => {
        let pageType = 'ROS';
        let sub_paths = window.location.pathname.replace("/", "").split("/") || [];
  		let custom_paths = [];

        sub_paths = sub_paths.filter(String);

        if(sub_paths.length === 0) {
          pageType = "Home";
        } else if (sub_paths.length === 1 || sub_paths.length === 2) {
          pageType = "Category";
        } else if (sub_paths.length >= 3 && sub_paths.indexOf('article') > -1) {
          pageType = "Article";
        }
        resolve(pageType)
   });
};
module.exports = pageSense;